import { InflateRequestMode } from '@sccs/types';
import { DlsAlternative } from '../http/clients/dls/DlsClientAlternative';
import { DlsSearch } from '../http/clients/dls/DlsClientSearch';
import { DlsTeaser } from '../http/clients/dls/DlsClientTeaser';
import { OneSearchVehicleTileDataParams } from '../http/clients/onesearch/graphql/OneSearchGraphQL';
import { SharedRequestConfiguration, VehicleParameterUnion } from '../types/GeneralParameter';
import { RequestParamsRawData } from '../types/raw/RequestParams';

export function getDataFromParameters(
  configuration: SharedRequestConfiguration,
  parameter: VehicleParameterUnion,
): {
  brand: string;
  ctx?: string;
} {
  const isFocMarket = configuration.isFoc;

  switch (configuration.mode) {
    case InflateRequestMode.BANNER_CAMPAIGN:
    case InflateRequestMode.SIMPLE_PRICE: {
      if (isFocMarket) {
        return {
          brand: (parameter as DlsSearch).filterCriteria?.brand[0] ?? 'Mercedes-Benz',
          ctx: (parameter as OneSearchVehicleTileDataParams).contextType,
        };
      } else {
        return {
          brand: (parameter as DlsSearch)?.filterCriteria?.brand?.[0] ?? 'Mercedes-Benz',
          ctx: (parameter as DlsSearch).ctx,
        };
      }
    }
    case InflateRequestMode.PI_PAGES_CARS:
    case InflateRequestMode.PI_PAGES_VANS:
    case InflateRequestMode.HOMEPAGE_CARS:
    case InflateRequestMode.HOMEPAGE_VANS:
    case InflateRequestMode.CAMPAIGN_TEASER_CARS:
    case InflateRequestMode.CAMPAIGN_TEASER_VANS: {
      if (isFocMarket) {
        const brands = (parameter as OneSearchVehicleTileDataParams).brand;
        return {
          brand: Array.isArray(brands) && brands.length > 0 ? brands[0] : 'Mercedes-Benz',
          ctx: (parameter as OneSearchVehicleTileDataParams).contextType,
        };
      } else {
        return {
          brand: (parameter as DlsTeaser).filterCriteria.brand.at(0) ?? 'Mercedes-Benz',
          ctx: (parameter as DlsTeaser).ctx,
        };
      }
    }
    case InflateRequestMode.ZERO_RESULT: {
      return {
        brand: (parameter as DlsAlternative).filterCriteria.brand ?? 'Mercedes-Benz',
        ctx: (parameter as DlsAlternative).ctx,
      };
    }
    case InflateRequestMode.VEHICLE_MATCH_TEASER: {
      return {
        brand: 'Mercedes-Benz',
      };
    }

    case InflateRequestMode.PERSONALIZED_T4: {
      return {
        brand: (parameter as RequestParamsRawData).brand ?? 'Mercedes-Benz',
      };
    }

    default:
      return {
        brand: 'Mercedes-Benz',
      };
  }
}
